"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  EMAIL_ALIAS_SIGNATURE_CHANGED: null,
  EMAIL_CONTENT_PASTED: null,
  EMAIL_QUOTE_LINK_INSERTED: null,
  EMAIL_RESET: null,
  EMAIL_SEND_SUCCEEDED: null,
  EMAIL_SEND_WITH_BRANDING_BANNER: null,
  EMAIL_SEND_FAILED: null,
  EMAIL_SEND_WITH_USER_ENTERED_ALIAS: null,
  EMAIL_TRACKING_TOOLTIP_DISMISSED: null
});

exports.default = _default;
module.exports = exports.default;